function contactFormCaptchaCallback() {
    const form = $(".g-recaptcha").closest("form").get(0);
    if (form.isValid()) {
        form.submit();
    }
}